import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import './css/Map.css'

export default function Events(){
    
    const openPopup = (e) => {
        window.setTimeout(() => {
                e.openPopup();
        })
    }

    return (
        <section className="section-bg map-section">
            <div className="container">
                <div className="row text-center" data-aos="fade-down" data-aos-delay="100">
                    <div className="col-lg-12">
                        <h1 className="section-title-dark">Location</h1>
                        <h1><a className="section-subtitle-dark" href="https://www.baliworldhotel.com/" rel="noopener noreferrer" target="_blank" title="Go To Hotel Website">Bali World Hotel </a></h1>
                        <span className="section-item-dark">Soekarno-Hatta St By Pass Timur No.713, Jatisari, Buahbatu, Bandung City, West Java 40286</span>
                        <MapContainer center={[-6.938335342072811, 107.66324289787417]} zoom={13} scrollWheelZoom={false} dragging={false}>
                            <TileLayer
                                attribution="Sani and Rijal's Wedding"
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[-6.938335342072811, 107.66324289787417]} ref={openPopup}>
                                <Popup>
                                <span className='btn btn-sm btn-primary btn-datagrid-filter' onClick={() => openMap([-6.938335342072811, 107.66324289787417])}>Open Map</span>
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>
                </div>
            </div>
        </section>
    )
}

function openMap(latLong){
    window.open('https://www.google.co.id/maps/place/Bali+World+Hotel/@-6.9383326,107.6621486,18z/data=!4m8!3m7!1s0x2e68e81c874fdb77:0x3594362f0a4a70c4!5m2!4m1!1i2!8m2!3d-6.9384525!4d107.6632429', '_blank');
}